<!-- eslint-disable vue/multi-word-component-names -->
<script lang="jsx">
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';

import storeAccount from '@/config/storeAccount.js';
// import storeMenu from '@/config/storeMenu.js';
import { HeaderLayout } from 'ai-assistant-lib';

import DialogPassword from './DialogPassword.vue';
import DialogCertificate from './DialogCertificate.vue';
import DialogUserCenter from './DialogUserCenter.vue';
// import SelectTree from '@/components/template/SelectTree.vue';
import { toLoginPage } from '@/utils/router';

export default {
  components: { HeaderLayout, DialogPassword, DialogCertificate },
  props: {
    menus: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const router = useRouter();
    const route = useRoute();
    /* let Area = (
      <SelectTree />
      // <OrgCascader orgId={localStorage.getItem('area')} onChange={orgChange}/>
    ); */
    const passwordShow = ref(false);
    const certificateShow = ref(false);
    const userCenterShow = ref(false);
    let store = storeAccount();

    const handleCommand = (command) => {
      const commandFun = {
        password() {
          passwordShow.value = true;
        },
        userCenter() {
          // router.push({ name: '/portal/userCenter' });
          userCenterShow.value = true;
        },
        logout() {
          store.Logout().then(() => {
            // toLoginPage(store.loginType, router, route);
            if (sessionStorage.getItem('controlConsole')) {
              router.push({ name: 'login' });
            } else {
              sessionStorage.removeItem('controlConsole');
              toLoginPage(store.loginType, router, route);
            }
          });
        },
        certificate() {
          certificateShow.value = true;
        },
      };
      commandFun[command]();
    };

    return () => [
      <HeaderLayout
        class="header"
        home-route-name={sessionStorage.getItem('controlConsole') ? '' : 'home'}
        menus={props.menus}
      >
        {{
          right: () => (
            /* {Area} */

            // {store.loginType == '4' ? <el-dropdown-item command='certificate'>企业认证</el-dropdown-item> : null}
            //  {store.loginType == '4' ? <el-dropdown-item command='password'>修改密码</el-dropdown-item> : null}
            <el-dropdown
              trigger="click"
              popper-class="portal-user-dropdown"
              onCommand={handleCommand}
              v-slots={{
                dropdown: () => (
                  <el-dropdown-menu>
                    <p class="drop-username">{store.userName}</p>
                    <el-dropdown-item command="userCenter">用户信息</el-dropdown-item>
                    <el-dropdown-item command="password">修改密码</el-dropdown-item>
                    {store.isGetInfo ? (
                      <el-dropdown-item command="logout" divided={store.loginType == '4'}>
                        退出
                      </el-dropdown-item>
                    ) : null}
                  </el-dropdown-menu>
                ),
              }}
            >
              <span class="account">
                <el-avatar icon="UserFilled" src={store.info.avatar} />
                <span class="account-name">{store.userName}</span>
                <el-icon size={16} class="icon-handle">
                  <CaretBottom />
                </el-icon>
              </span>
            </el-dropdown>
          ),
        }}
      </HeaderLayout>,
      <DialogPassword class="dialog-password" v-model:visible={passwordShow.value} />,
      <DialogCertificate v-model:visible={certificateShow.value} />,
      <DialogUserCenter class="dialog-user-center" v-model:visible={userCenterShow.value} />,
    ];
  },
};
</script>
<style lang="scss" scoped>
.header {
  .header-link {
    color: #fff;
    position: absolute;
    right: 14%;
    font-size: 15px;
  }

  :deep(.el-dropdown) {
    margin-left: 10px;
    flex-shrink: 0;
  }

  .drop-username {
    margin: 0.5rem;
    font-size: 0.875rem;
    // color: #404040;
    width: 120px;
  }
}

.account {
  display: flex;
  align-items: center;
  user-select: none;
  margin-left: 10px;
  cursor: pointer;

  :deep(.el-avatar) {
    width: 36px;
    height: 36px;
  }

  .account-name {
    margin: 0px 4px 0 10px;
    color: #535f6e;
  }

  .icon-handle {
    margin-top: -4px;
  }
}
</style>
<style lang="scss">
.portal-user-dropdown {
  .drop-username {
    margin: 0.5rem;
    font-size: 0.875rem;
    // color: #404040;
    width: 120px;
  }
}

.dialog-user-center {
  .licence {
    background: #f4f5f9;
    i {
      color: #bac3d1;
    }
  }
}

.dialog-password {
  // display: none;
  .el-button.is-plain {
    span {
      color: #0047ea;
    }
    i {
      color: #0047ea !important;
    }
  }
}
</style>
